import {
  Typography,
  Drawer,
  Grid2,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Avatar,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import {
  Assignment,
  Home,
  Logout,
  Message,
  Search,
  Settings,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../redux/userSlice";
import { clearLocalStorage, getUserPhotoSrc } from "../utils/utils";
import constants from "../static/constants.json";

type MainMenuProps = {
  open: boolean;
  onClose: () => void;
};

const MainMenu = ({ open, onClose }: MainMenuProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);

  const signOutUser = () => {
    clearLocalStorage();
    dispatch(setUser({}));
    navigate("/");
  };

  const gridItemStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <Drawer open={open} anchor="right" onClose={() => onClose()}>
      <Grid2
        container
        sx={{
          width: "20rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        spacing={4}
      >
        <Grid2 size={12} sx={{...gridItemStyle, marginTop: '3rem'}}>

         <Avatar alt="u" src={getUserPhotoSrc(user.id)} />

        </Grid2>
        <Grid2 size={12} sx={gridItemStyle}>
          <Typography variant="h5">{user.name}</Typography>
        </Grid2>
        <Grid2 size={12} sx={gridItemStyle}>
          <Typography>{user.email}</Typography>
        </Grid2>
        <Grid2 size={12} sx={{}}>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  onClose();
                  navigate("/messages");
                }}
              >
                <ListItemIcon>
                  <Message />
                </ListItemIcon>
                <ListItemText primary="Messages" />
              </ListItemButton>
            </ListItem>
            {user.personTypeId === constants.personType.propertyManager ? (
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      onClose();
                      navigate("/");
                    }}
                  >
                    <ListItemIcon>
                      <Assignment />
                    </ListItemIcon>
                    <ListItemText primary="Job Postings" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      onClose();
                      navigate("properties");
                    }}
                  >
                    <ListItemIcon>
                      <Home />
                    </ListItemIcon>
                    <ListItemText primary="Manage Properties" />
                  </ListItemButton>
                </ListItem>
              </>
            ) : null}

            {user.personTypeId === constants.personType.worker ? (
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      onClose();
                      navigate("/jobs");
                    }}
                  >
                    <ListItemIcon>
                      <Search />
                    </ListItemIcon>
                    <ListItemText primary="Find Jobs" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      onClose();
                      navigate("/assignments");
                    }}
                  >
                    <ListItemIcon>
                      <Assignment />
                    </ListItemIcon>
                    <ListItemText primary="Assignments" />
                  </ListItemButton>
                </ListItem>
              </>
            ) : null}

            {/* <ListItem disablePadding>
              <ListItemButton onClick={() => {
                      onClose();
                      navigate("/settings");
                    }}>
                <ListItemIcon>
                  <CreditCard />
                </ListItemIcon>
                <ListItemText primary="Payment Settings" />
              </ListItemButton>
            </ListItem> */}

            <ListItem disablePadding>
              <ListItemButton onClick={() => {
                      onClose();
                      navigate("/settings");
                    }}>
                <ListItemIcon>
                  <Settings />
                </ListItemIcon>
                <ListItemText primary="Settings" />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  signOutUser();
                  onClose();
                }}
              >
                <ListItemIcon>
                  <Logout />
                </ListItemIcon>
                <ListItemText primary="Sign Out" />
              </ListItemButton>
            </ListItem>
          </List>
        </Grid2>
        {/* <Grid2 size={12} sx={gridItemStyle}>
          <Button onClick={() => {}}>Sign Out</Button>
        </Grid2> */}
      </Grid2>
    </Drawer>
  );
};

export default MainMenu;
